( function( global, $ ) {
    "use strict";

    var _events = {
        onFormAutoSubmit: function(ev) {
            ev.preventDefault();

            var $form = $(this),
                $target = $(ev.target);

            if ($form.data('form-autosubmit') === false || $target.data('form-autosubmit') === false) {
                return;
            }

            $(this).trigger('submit');
        },

        onInputAutoSubmit: function(ev) {
            var $input = $(this);

            if ($input.data('form-autosubmit') === false) {
                return;
            }

            $(this.form).trigger('submit');
        },

        onFormDeleteEntry: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                $form = $this.closest('form'),
                $entry = $this.closest('[data-form-entry]');

            if ($this.data('form-delete-entry') === 'confirm') {
                return;
            }

            $entry.find('*').remove();

            if ($form.is('[data-form-autosubmit]') || $this.data('form-delete-entry') === 'submit') {
                $form.trigger('submit');
            }
        },

        onFormCancelEntry: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                $target = $('#' + $this.data('form-cancel-entry')),
                $form = $($target.get(0).form);

            $target
                .prop('checked', true)
                .trigger('change');

            if ($this.data('form-trigger') === 'submit') {
                $form.trigger('submit');
            }
        },

        onFormUncancelEntry: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                $target = $('#' + $this.data('form-uncancel-entry')),
                $form = $($target.get(0).form);

            $target
                .prop('checked', false)
                .trigger('change');

            if ($this.data('form-trigger') === 'submit') {
                $form.trigger('submit');
            }
        },

        onFormTargetContainer: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                $form = $this.closest('form'),
                target = $this.data('form-target-container'),
                $target = $form.find('[data-form-container="'+target+'"]'),
                $targetInput = $target.find(':input').first();

            $target.removeClass('hidden');
            $this.addClass('hidden');

            if ($targetInput.length) {
                if ($targetInput.get(0).selectize) {
                    $targetInput.get(0).selectize.focus();
                } else {
                    $targetInput.focus();
                }
            }
        },

        onFormOutsideInputChange: function(ev) {
            ev.preventDefault();

            var $form = $('#' + $(this).attr('form'));

            $form.trigger('change');
        },

        onFormClear: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                selector = $(this).data('form-clear'),
                $target = selector ? $(selector) : $($this.get(0).form);

            if ($target.length === 0) {
                return;
            }

            if ($target.prop('tagName') === 'FORM') {
                // Todo
                $target.find(':input').val('').trigger('change');
            } else {
                if ($target.get(0).selectize) {
                    $target.get(0).selectize.clear();
                } else {
                    $target.val('').trigger('change');
                }
            }
        }
    };

    var $body = $('body');

    $body.on('app.ready', function(ev) {
        $body.on('click', 'form[data-form-ajax] a[data-form-cancel]', window.onAjaxLink);
        $body.on('submit', 'form[data-form-ajax]', window.onAjaxSubmit);
        $body.on('click', '[data-form-delete-entry]', _events.onFormDeleteEntry);
        $body.on('click', '[data-form-cancel-entry]', _events.onFormCancelEntry);
        $body.on('click', '[data-form-uncancel-entry]', _events.onFormUncancelEntry);
        $body.on('click', 'form [data-form-target-container]', _events.onFormTargetContainer);
        $body.on('change', ':input[data-form-autosubmit]', _events.onInputAutoSubmit);
        $body.on('change', ':input[form]', _events.onFormOutsideInputChange);
        $body.on('click', 'button[data-form-clear]', _events.onFormClear);
    });

    $body.on('app.initafter', function(ev) {
        var $container = $(ev.container);

        $container.find('form[data-form-autosubmit]').on('change', _events.onFormAutoSubmit);
    });

}( window.groots, jQuery ));
